module.exports = __webpack_public_path__ + "static/img/011.b1b6d4d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cultours/tour3/011.jpg
// module id = MYfZ
// module chunks = 0